export default {
  apiKey: "AIzaSyBKCjbjrRI8-fg1m8rzQI3-eQ2JS68L7ew",
  authDomain: "testjewerkgeluk.firebaseapp.com",
  databaseURL: "https://testjewerkgeluk.firebaseio.com",
  projectId: "testjewerkgeluk",
  storageBucket: "testjewerkgeluk.appspot.com",
  messagingSenderId: "808650980286"
}



// WEBPACK FOOTER //
// ./src/components/firebaseConfigProd.js